import React from 'react';
import { RomaneioFornContent } from './RomaneioFornContent';
import { RomaneioFornProvider } from './context/RomaneioFornContext';

export const RomaneioDeFornecedor: React.FC = () => {
  return (
    <RomaneioFornProvider>
      <RomaneioFornContent />
    </RomaneioFornProvider>
  );
};
